import React, { useEffect, useState } from 'react';
import { MainTable } from '../../../Components/Macro/MainTable/MainTable';
import Add from './Add';
import Edit from './Edit';
import { usePosts } from './PostsState';
import { Modal } from 'antd';
import parse from 'html-react-parser';

function Posts() {
    let [current, setCurrent] = useState({
        title: '',
        body: ''
    })
    let [mopen, setMopen] = useState(false)
    let { columns, posts, setPosts, deletePost, setEd } = usePosts()
    useEffect(() => {
        setPosts()
    }, [])
    return (
        <>
            <Modal width={1200} open={mopen} onCancel={() => setMopen(false)} footer={false} title={current.title}>
                <div style={{ border: '1px solid silver', padding: '25px' }}>
                    {parse(current.body)}
                </div>
            </Modal>
            <MainTable
                pageTitle={"Maqolalar"}
                add={<Add />}
                defkey={'id'}
                edit={<Edit />}
                pcolumns={columns}
                pdata={posts}
                editTitle={"Matni"}
                adw={1400}
                edw={1400}
                onDelete={(_, id) => {
                    deletePost(id.id)
                }}
                onEdit={(data) => {
                    setEd(data)
                }}
                setEd={setEd}
                viewBtn={true}
                onView={(_, data) => {
                    setCurrent(data)
                    setMopen(true)
                }}
            />
        </>
    );
}

export default Posts;